import { useContext, useEffect } from 'react';
import { Divider, Text } from '@mantine/core';
import { useJwtClaims } from '../../../../Service/Context/AuthContext';
import { SemanticFormS } from '../../../../Service/restapi/semanticFormService';
import { BookitupFormContext } from '../../../../Service/Context/BookitupFormContext';
import CodeWithCopy from '../../../../Atoms/CodeWithCopy';
import { ThemeText } from '../../../../Atoms/ThemeText';

const FormCode = () => {
  const { profileId } = useJwtClaims();
  const { bookitupForm, handleChange } = useContext(BookitupFormContext);
  const { id: formId, outOfSync } = bookitupForm ?? {};

  useEffect(() => {
    if (outOfSync && formId) {
      SemanticFormS.syncFormFiles(formId).then((synced) => {
        if (synced) {
          handleChange({ outOfSync: false });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outOfSync, formId]);

  if (!formId) {
    return null;
  }

  return (
    <>
      <ThemeText weight="bolder" size="lg" mb="md" mt="md">
        iFrame (empfohlen)
      </ThemeText>
      <CodeWithCopy content={SemanticFormS.generateIframeCodeV2(formId, profileId)} />
      <ThemeText weight="bolder" size="lg" mb="md" mt="md">
        Script
      </ThemeText>
      <CodeWithCopy content={SemanticFormS.generateJsCodeV2(formId, profileId)} />
      <Text size="xs" mt={5} color="dimmed">
        Falls du eine Danke-Seite verlinkt oder eigene Schriftarten angegeben hast, solltest du das Formular mit dieser Variante in deine Webseite einfügen.{' '}
      </Text>
      <Divider mt="xl" />
      <ThemeText weight="bolder" size="lg" mb="md" mt="md">
        Mini-Webseite
      </ThemeText>
      <CodeWithCopy
        includeOpenLinkIcon
        content={SemanticFormS.createStandaloneSemanticFormIframeUrl(profileId, formId)}
      />
      <Text size="xs" mt={5} color="dimmed">
        Falls du keine Webseite hast oder dein Webseitenbaukasten wie Jimdo es nicht erlaubt Code hinzuzufügen, kannst
        du diesen Link nutzen, um auf dein Kontaktformular zu verweisen. In dem Fall kannst du mit Elementen wie
        Überschrift, Ettikett und einem Hintergrundbild eine Mini-Webseite bauen, die deinem Branding entspricht.{' '}
      </Text>
    </>
  );
};

export default FormCode;
